export type InterviewTerminalPresentationKind =
  | 'incomplete'
  | 'technical_failure'
  | 'employer_ended';

const TECHNICAL_FAILURES = new Set([
  'technical_media_failure',
  'technical_recording_failure',
  'technical_upload_failure',
]);

export function interviewTerminalPresentationKind(input: {
  status: string;
  terminalReasonCode?: string | null;
  failureReason?: string | null;
}): InterviewTerminalPresentationKind | null {
  const reason = input.terminalReasonCode ?? input.failureReason ?? '';
  if (input.status === 'cancelled' && reason.startsWith('recruiter_ended_in_progress:')) {
    return 'employer_ended';
  }
  if (input.status !== 'incomplete') return null;
  if (TECHNICAL_FAILURES.has(reason)) return 'technical_failure';
  return 'incomplete';
}

export function safeInterviewTerminalReasonKey(reason?: string | null): string {
  if (reason?.startsWith('recruiter_ended_in_progress:')) {
    return `manual_${reason.slice('recruiter_ended_in_progress:'.length)}`;
  }
  return reason ?? 'candidate_disconnected_timeout';
}

export function isDisplayOnlyZeroOutcome(input: {
  status: string;
  terminalReasonCode?: string | null;
  failureReason?: string | null;
  overallScore: number | null;
}): boolean {
  return input.overallScore === null && interviewTerminalPresentationKind(input) !== null;
}
